<template>
  <b-form-group
    label="Ürün"
    label-for="id_projects"
  >
    <validation-provider
      #default="{ errors }"
      name="Ürün"
      rules="required"
    >
      <v-select
        id="id_projects"
        v-model="dataItem.id_projects"
        label="title"
        :options="projects"
        :reduce="project => project.id"
        placeholder="Seçiniz"
        @input="getLimits"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
// eslint-disable-next-line no-unused-vars
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'ProjectPackageProject',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      locale: 'tr',
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['projectPackages/dataItem']
    },
    projects() {
      return this.$store.getters['projects/dataList']
    },
  },
  created() {
    localize(this.locale)
    this.getProjects()
  },
  methods: {
    getLimits() {
      this.dataItem.package_limits = []
      if (this.dataItem.id_projects) {
        this.$store.dispatch('packageLimitParamsSchemes/getDataList', {
          select: [
            'package_limit_params_schemes.id AS id',
            'package_limit_params_schemes.title AS title',
            'package_limit_params_schemes.type AS type',
            'package_limit_params_schemes.param_text AS param_text',
            'package_limit_params_schemes.default_value AS default_value',
            'package_limit_params_schemes.disabled AS disabled',
          ],
          where: {
            'package_limit_params_schemes.id_projects': this.dataItem.id_projects,
          },
        })
          .then(response => {
            if (response.length > 0) {
              response.forEach((item, index) => {
                if (item.default_value) {
                  // eslint-disable-next-line no-param-reassign
                  item.limit = item.default_value
                }
              })
              this.dataItem.package_limits = response
            }
          })
      }
    },
    getProjects() {
      this.$store.dispatch('projects/getDataList', {
        select: [
          'projects.id AS id',
          'projects.title AS title',
        ],
        where: {
          'projects.status': 1,
        },
      })
    },
  },
}
</script>

<style scoped></style>
